import { render, staticRenderFns } from "./StudyOnline.vue?vue&type=template&id=070a1e62"
import script from "./StudyOnline.vue?vue&type=script&lang=js"
export * from "./StudyOnline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports